module.exports = __webpack_public_path__ + "static/our-mission1-a53c633d940c4cf7f8b70e676a16332b.png";